import type { PayerPlanType, PayerRow } from './types';

// Only published Stedi classifications belong in the selectable catalog.
const STEDI_PROGRAM_OPTIONS: { value: PayerPlanType; label: string }[] = [
  { value: 'automobile_medical', label: 'Automobile Medical' },
  { value: 'commercial', label: 'Commercial' },
  { value: 'disability', label: 'Disability' },
  { value: 'liability_medical', label: 'Liability Medical' },
  { value: 'medicaid', label: 'Medicaid' },
  { value: 'medicare', label: 'Medicare' },
  { value: 'medicare_advantage', label: 'Medicare Advantage' },
  { value: 'title_v', label: 'Title V' },
  { value: 'tricare', label: 'TRICARE' },
  { value: 'veterans_affairs', label: 'Veterans Affairs' },
  { value: 'workers_compensation', label: 'Workers’ Compensation' },
];

export function payerPrograms(programs: PayerRow['programs']): string[] {
  return [
    ...new Set((programs ?? []).map(program => program.trim().toLowerCase()).filter(Boolean)),
  ];
}

export function payerPlanOptions(programs: PayerRow['programs']) {
  const published = payerPrograms(programs);
  return STEDI_PROGRAM_OPTIONS.filter(option => published.includes(option.value));
}

/** A singleton published program is the default; mixed or unknown programs need no guess. */
export function initialPayerPlanTypes(programs: PayerRow['programs']): PayerRow['planTypes'] {
  if (payerPrograms(programs).length !== 1) return null;
  const [plan] = payerPlanOptions(programs);
  return plan ? [plan.value] : null;
}

export function payerPlanLabel(plan: PayerPlanType): string {
  if (plan === 'managed_medicaid') return 'Managed Medicaid';
  if (plan === 'other') return 'Other';
  return STEDI_PROGRAM_OPTIONS.find(option => option.value === plan)?.label ?? plan;
}
